import {
  Modal,
  Backdrop,
  Box,
  Grid,
  Button,
  Paper,
  Stack,
  Link,
} from "@mui/material";
import React, { useState } from "react";
import Fade from "@mui/material/Fade";
import Typography from "@mui/material/Typography";
import LaunchIcon from "@mui/icons-material/Launch";

import HomeIcon from "../assets/homePlanIcon.png";
import BusinessIcon from "../assets/businessPlanIcon.png";

import plans from "../plan-configuration.json";

// TODO: Fix top: 46%, was playing around to make it work on desktop, laptop and phone...
const style = {
  position: "absolute",
  top: "45%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "85%",
  minWidth: "200px",
  maxWidth: "1400px",
  bgcolor: "background.paper",
  border: "1px solid #DFDFDF",
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
  maxHeight: "87vh",
  overflowY: "scroll",
};

function PlansModal(props) {
  const [selectedPlanDetails, setSelectedPlanDetails] = useState(
    plans["saSustainableHomePlan"]
  );

  const handleSelectedPlanUpdate = (planName) => {
    // alert("Changed selected plan!");
    console.log("Selected: ", planName);
    setSelectedPlanDetails(plans[planName]);
  };

  const handleAddPlan = () => {
    // alert("adding plan");
    props.addItem(selectedPlanDetails.planName);
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={props.open}
      onClose={props.handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={props.open}>
        <Box sx={style}>
          <Grid container spacing={1}>
            <Grid
              id="left-panel"
              item
              xl={8}
              lg={8}
              md={12}
              sm={12}
              xs={12}
              px={1}
            >
              <Grid item lg={12} border={"0px solid purple"}>
                <Typography variant="h2" sx={{ mb: 2, fontSize: "50px" }}>
                  Choose a plan.
                </Typography>
              </Grid>
              <Stack border={"0px solid red"} spacing={2}>
                {Object.entries(plans).map(([key, value], i) => (
                  <div key={i}>
                    <Grid
                      item
                      className="modal-plan-wrapper"
                      sx={{
                        p: 3,
                        py: 6,
                        // my: 2,
                        borderRadius: 10,
                        ":hover": {
                          border: "3px solid purple",
                          boxShadow: "5px 5px #522973",
                          cursor: "pointer",
                        },
                        ":hover #planTitle": {
                          color: "black",
                        },
                        ":hover #planDesc": {
                          color: "purple",
                        },
                      }}
                      border={
                        selectedPlanDetails.planName === value.planName
                          ? "3px solid purple"
                          : "2px solid rgba(144, 147, 163, 1)"
                      }
                      boxShadow={
                        selectedPlanDetails.planName === value.planName
                          ? "5px 5px #522973"
                          : ""
                      }
                      onClick={() => handleSelectedPlanUpdate(key)}
                    >
                      <Typography
                        variant="h4"
                        id="planTitle"
                        color={
                          selectedPlanDetails.planName === value.planName
                            ? "black"
                            : "rgba(144, 147, 163, 1)"
                        }
                      >
                        {value.formattedPlanName}
                      </Typography>
                      <Typography
                        variant="h5"
                        id="planDesc"
                        color={
                          selectedPlanDetails.planName === value.planName
                            ? "purple"
                            : "rgba(144, 147, 163, 1)"
                        }
                        sx={{ mb: 0 }}
                      >
                        {value.planDescriptor}
                      </Typography>
                      <Typography>{value.basicPlanInformation}</Typography>
                    </Grid>
                  </div>
                ))}
              </Stack>
            </Grid>
            <Grid
              id="modal-right-panel"
              item
              container
              xl={4}
              lg={4}
              md={0}
              sm={0}
              xs={0}
              justifyContent="center"
              alignContent="center"
              width="calc(100% - 10px)"

              // height="100%"
              // sx={{ py: 3 }}
            >
              <Paper
                sx={{
                  // border: "2px solid red",
                  border: "1px solid #DFDFDF",
                  p: 5,
                  width: "calc(100% - 10px)",
                  borderRadius: "15px",
                  boxShadow: "0px 5px 4px 0px #00000040",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  boxSizing: "border-box",
                }}
              >
                <Stack alignItems={"center"}>
                  <img
                    width={"60%"}
                    alt="plan details card"
                    src={
                      selectedPlanDetails.planName === "saSmartBusinessPlan"
                        ? BusinessIcon
                        : HomeIcon
                    }
                  />
                  <Grid
                    item
                    id="bpid-detail-container"
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    sx={{ textAlign: "center" }}
                    justifyContent="center"
                  >
                    <Button
                      variant="contained"
                      data-cy="add-plan"
                      color={"tertiary"}
                      sx={{
                        my: 3,
                        py: 1,
                        px: 3,
                        borderRadius: "10px",
                      }}
                      onClick={() => handleAddPlan()}
                    >
                      + Add {selectedPlanDetails.shortName}
                    </Button>

                    <Grid item>
                      <Link
                        href="https://www.ioenergy.com.au/bpids"
                        variant="subtitle1"
                        color={"#8496A6"}
                      >
                        Basic Plan Information
                        <LaunchIcon sx={{ ml: "5px", verticalAlign: "top" }} />
                      </Link>
                    </Grid>
                  </Grid>
                </Stack>
              </Paper>
            </Grid>
          </Grid>
        </Box>
      </Fade>
    </Modal>
  );
}

export default PlansModal;
